import script from "./AppLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLogs.vue?vue&type=script&setup=true&lang=js"

import "./AppLogs.vue?vue&type=style&index=0&id=57ba7456&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ba7456"]])

export default __exports__